import React, {Fragment} from 'react';

export default function QuestionsColumn({displayedQuestions, openedDay, logGroupLabel}) {
  return (
    <div className="questions">
      <div className="question-placeholder">#</div>
      <div className="question-placeholder">#</div>
      {!openedDay && (
        <Fragment>
          <div className="question-placeholder">#</div>
          <div className="question-placeholder">#</div>
        </Fragment>
      )}
      {!!openedDay && <div className="question">
        {logGroupLabel}
      </div>}
      {displayedQuestions.map(question => (
        <div className="question" title={question} key={question}>
          {question}
        </div>
      ))}
      <div className="question" title="Time spend summary" key="time-spend-summary">
        Time spend summary
      </div>
    </div>
  )
}
